import InquiryApi from '@apis/inquiry/InquiryApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { CreateInquiryRequest } from '@models/inquiry';
import { useFlow, useStepFlow } from '@router/stackflow';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';

function useInquiryForm() {
  const [inquiryTypeId, setInquiryTypeId] = useState<string>('');
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const [fileUrls, setFileUrls] = useState<string[]>([]);
  const toast = useToast();
  const [privacy, setPrivacy] = useState<boolean>(false);
  const { stepReplace } = useStepFlow('InquiryActivity');
  const { push } = useFlow();

  const reset = () => {
    setInquiryTypeId('');
    setTitle('');
    setContent('');
    setFileUrls([]);
    setPrivacy(false);
  };

  const { mutate } = useMutation({
    mutationFn: InquiryApi.createInquiry,
    onSuccess(data) {
      toast.success('문의가  등록되었습니다.');
      reset();
      const { inquiryId } = data;
      stepReplace({ type: 'READ' });
      push('InquiryLogActivity', { inquiryId });
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '문의 등록에 실패했습니다.');
    },
  });

  const handleCreateInquiry = () => {
    if (!inquiryTypeId) {
      toast.error('문의 유형을 선택해주세요.');
      return;
    }
    if (!title) {
      toast.error('제목을 입력해주세요.');
      return;
    }
    if (!content) {
      toast.error('내용을 입력해주세요.');
      return;
    }
    if (!privacy) {
      toast.error('개인정보 수집 및 활용에 동의해주세요.');
      return;
    }
    const request: CreateInquiryRequest = {
      inquiryTypeId, title, content, fileUrls,
    };
    mutate(request);
  };
  return {
    inquiryTypeId,
    setInquiryTypeId,
    title,
    setTitle,
    content,
    setContent,
    fileUrls,
    setFileUrls,
    handleCreateInquiry,
    reset,
    privacy,
    setPrivacy,
  };
}

export default useInquiryForm;
